var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgTableTick = function SvgTableTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.048 6.352a1.2 1.2 0 010 1.696l-9.6 9.6a1.2 1.2 0 01-1.696 0l-4.8-4.8a1.2 1.2 0 011.696-1.696L9.6 15.103l8.752-8.751a1.2 1.2 0 011.696 0z",
    fill: "#9CA6AD"
  })));
};

export default SvgTableTick;